// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  worldId: __t.u64().name("world_id"),
  cellX: __t.i32().name("cell_x"),
  cellZ: __t.i32().name("cell_z"),
  posX: __t.f32().name("pos_x"),
  posY: __t.f32().name("pos_y"),
  posZ: __t.f32().name("pos_z"),
  yaw: __t.f32(),
  animState: __t.string().name("anim_state"),
  inputSeq: __t.u32().name("input_seq"),
  updatedAt: __t.timestamp().name("updated_at"),
});
